
import { makeAutoObservable } from 'mobx';


interface DopType {
    id_okno_dopolnitelno: number,
    insert_pole: string
    insert_pole_kg: string
    coment: string
}

interface AcademType{
    rowNum: string
    id_direction: number
    p24: string | null
    p24_kg: string | null
    p24_en: string | null
    total: string
    pages: number
    pageStart: string | number
    pageEnd: string | string
}


class Direction {

    dops: DopType[] = []
    direction = []
    sdd: number = 1
    sddText: string = ""
    page: number = 1
    leftOrRight: string = "left"
    academ: AcademType [] = [
    ]

    constructor(){
        makeAutoObservable(this)

    }

    newDirection(param: any){
        this.direction = param
    }

    newAcadem( param: AcademType [] ){
        this.academ = param
    }

    newDops(param: DopType[]): void {
        this.dops = param

    }
    newLeftOrRight(param: string) {
        this.leftOrRight = param

    }
    setSDD(param: number){
        this.sdd = param
    }
    setSddText(param: string){
        this.sddText = param
    }
    setPage(param: number){
        this.page = param
    }

}

export const direction = new Direction()